import { Box } from '@bechtel/gds';
import styled, { css } from 'styled-components';

export const ReqHeaderStyled = styled(Box).attrs({
  p: { sm: '500' },
  justifyContent: { sm: 'space-between' },
})`
  ${({ theme }) => css`
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
  `}
`;
